/**
 * JALRAKSHAK Digital Visiting Card & vCard Manager
 */

import { FOUNDER_DATA, generateVCardString } from '../data/founderData.js';

export function initVCard() {
  const vcardWrapper = document.querySelector('.vcard-3d-wrapper');
  const vcardFlipper = document.querySelector('.vcard-flipper');
  const flipBtn = document.querySelector('.vcard-flip-toggle-btn');
  const downloadVcfBtn = document.getElementById('btn-download-vcf');
  const copyDetailsBtn = document.getElementById('btn-copy-contact');

  // Flip 3D card on click
  function toggleFlip() {
    vcardWrapper?.classList.toggle('is-flipped');
  }

  vcardFlipper?.addEventListener('click', toggleFlip);
  flipBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    toggleFlip();
  });

  // Download .VCF contact card
  downloadVcfBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    const vcardData = generateVCardString('all');
    const blob = new Blob([vcardData], { type: 'text/vcard;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'JALRAKSHAK_Founders.vcf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    showToast('Founders vCard downloaded successfully!');
  });

  // Copy details to clipboard
  copyDetailsBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    const contactText = `JALRAKSHAK - Autonomous Water System\n\nFounder: Chetan Punj\nPhone: +91 8409771216\nEmail: chetanpunj481@gmail.com\nLinkedIn: https://linkedin.com/in/chetan-punj\nGitHub: https://github.com/Chetan2835\n\nFounder: Anmol Agarwal\nPhone: +91 6367445454\nEmail: reachoutanmolag@gmail.com\nLinkedIn: https://linkedin.com/in/anmol\n\nWebsite: https://jalrakshak.in`;
    
    navigator.clipboard.writeText(contactText).then(() => {
      showToast('Founders contact details copied to clipboard!');
    }).catch(() => {
      showToast('Failed to copy details');
    });
  });

  // General click-to-copy buttons
  document.querySelectorAll('[data-copy]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const textToCopy = el.dataset.copy;
      navigator.clipboard.writeText(textToCopy).then(() => {
        showToast(`Copied: ${textToCopy}`);
      });
    });
  });
}

export function showToast(message) {
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#00F0FF" stroke-width="2">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke-linecap="round" stroke-linejoin="round"/>
      <polyline points="22 4 12 14.01 9 11.01" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>${message}</span>
  `;

  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(100%)';
    toast.style.transition = 'all 0.3s ease';
    setTimeout(() => toast.remove(), 300);
  }, 3500);
}
